import { Reveal, SectionHeading } from "@/components/Reveal";
import { GALLERY } from "@/lib/site";

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="bg-stone-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          overline="Gallery"
          title={
            <>
              Seen at the <span className="italic bronze-text">finest gatherings</span>
            </>
          }
          description="Estate weddings, vineyard parties, gala evenings, and working production sets — a glimpse of where LooXury trailers live."
        />
        <div className="mt-16 columns-1 gap-6 sm:columns-2 lg:columns-3" data-testid="gallery-grid">
          {GALLERY.map((g, i) => (
            <Reveal key={g.src} delay={(i % 3) * 0.08} className="mb-6 break-inside-avoid">
              <figure className="group relative overflow-hidden border border-stone-200 bg-white p-2">
                <img
                  src={g.src}
                  alt={g.caption}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  data-testid={`gallery-image-${i}`}
                />
                <figcaption className="pointer-events-none absolute inset-2 flex items-end bg-gradient-to-t from-stone-950/60 via-transparent to-transparent p-5 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="font-serif text-lg font-light italic text-stone-50">{g.caption}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
